import { render, staticRenderFns } from "./mmMenuItem.vue?vue&type=template&id=32683e61"
import script from "./mmMenuItem.vue?vue&type=script&lang=js"
export * from "./mmMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports